import React from 'react'
import { connect } from 'react-redux'
import { NavLink, withRouter } from 'react-router-dom'

import Button from './Button'
import { HEADER_TABS } from 'utils/consts'

import actions from '../store/actions'
import dispatch from '../utils/dispatchStore'

import ufanetLogo from 'assets/images/ufanet-logo-white.svg'
import exitIcon from 'assets/images/exit.svg'

class Header extends React.Component {
  handleClick = () => {
    dispatch(actions.logout.removeData())
    this.props.history.push('/')
  }

  render() {
    return (
      <div className='header'>
        <div className='header__top'>
          <a href='https://ufanet.ru' target='_blank' rel='noopener noreferrer'>
            <img
              src={ufanetLogo}
              alt='ufanet logo'
              title='Перейти на сайт ufanet.ru'
            />
          </a>
          <div className='header__title'>
            Система контроля управления доступом
          </div>
          <Button
            className='btn--icon btn--padding0'
            icon={true}
            iconPicture={exitIcon}
            action={this.handleClick}
          />
        </div>
        <div className='header__bot'>
          <div className='header__tabs'>
            {HEADER_TABS.map(tab => (
              <NavLink
                className='tab'
                activeClassName='tab--active'
                key={tab.name}
                to={`${tab.name}`}>
                {tab.label}
              </NavLink>
            ))}
          </div>
        </div>
      </div>
    )
  }
}

export default connect(null, null)(withRouter(Header))
